module.exports = __webpack_public_path__ + "img/icon_manejo_de_referidos_mipe.9eac9793.svg";